/* eslint-disable unicorn/filename-case -- is a utility function which returns a ReactNode */
import type { ComponentType } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorDebugResult as DefaultErrorDebugResult, type ErrorDebugResultProperties } from '../error-debug-result';

export type WithErrorBoundaryOptions = {
  ErrorDebugResult?: ComponentType<Omit<ErrorDebugResultProperties, 'additionalData'>>;
} & Omit<ErrorDebugResultProperties, 'additionalData' | 'error'>;

const withErrorBoundary = <TProperties extends object>(
  Component: ComponentType<TProperties>,
  { ErrorDebugResult = DefaultErrorDebugResult, message, orientation, size }: WithErrorBoundaryOptions = {},
) =>
  function (properties: TProperties) {
    return (
      <ErrorBoundary
        fallbackRender={({ error }) => (
          <ErrorDebugResult error={error} message={message} orientation={orientation} size={size} />
        )}
      >
        <Component {...properties} />
      </ErrorBoundary>
    );
  };

export default withErrorBoundary;
/* eslint-enable unicorn/filename-case -- is a utility function which returns a ReactNode */
